import React from 'react';
import type { MStarGroupProps } from '../MStarGroup/MStarGroup.types';
import type { ALabelProps } from '../../atoms/ALabel/ALabel.types';
import type { ATextInteractiveProps } from '../../atoms/ATextInteractive/ATextInteractive.types';

export interface MRatingProps extends React.HTMLAttributes<HTMLDivElement> {
  singleStar?: boolean;
  mStarGroup: MStarGroupProps;
  aLabel: ALabelProps;
  aTextInteractive: ATextInteractiveProps;
}

export enum MRatingSingleStar {
  False = 'False',
  True = 'True',
}
